import React, { Component } from "react";
import RGL, { WidthProvider } from "react-grid-layout";
import { BsyUtils } from "../../../utils/Utils";
import BsyDashboardComponent from "../BsyDashboardComponent";
import "./index.css";
import DocumentTitle from "react-document-title";
import _ from "lodash";
import { createWidgetName } from "../../../utils/createWidgetName";
import { filterDuplicateWidgets } from "../../../utils/filterDuplicateWidgets";
import { normalizeComponents } from "../../../utils/normalizeComponents";
import BsyMaskLayer from "../../BsyMaskLayer";
import BsyMyAppGuide from "../../BsyGuide";
import { setPageTitle } from "../../../utils/setPageTitle";
const ReactGridLayout = WidthProvider(RGL);

export default class BsyDashboardCenter extends Component {
  static defaultProps = {
    isPreview: false,
    rowHeight: 18,
    cols: 60,
    dockCorp: [],
    dockItem: [],
    customApp: {},
    dockApp: {},
    customDash: {},
    speedyEntry: {},
    myDash: {},
    apps: [],
    dash_id: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      rowHeight: props.rowHeight,
      components: props.components,
      dockCorp: props.dockCorp,
      dockItem: props.dockItem,
      isPreview: props.isPreview,
      customApp: props.customApp,
      dockApp: props.dockApp,
      customDash: props.customDash,
      recentUse: props.recentUse,
      richText: props.richText,
      carouselMap: props.carouselMap,
      noticeBoard: props.noticeBoard,
      speedyEntry: props.speedyEntry,
      myDash: props.myDash,
      margin: [16, 16],
      preferences: props.preferences,
      apps: props.apps,
      flowManagementType: props.flowManagementType,
      dash_id: props.dash_id,
    };
    // 清理全局变量
    window.FX.STATIC.APPID = null;
    window.FX.STATIC.ENTRYID = null;
    window.FX.STATIC.appId = null;
    window.FX.STATIC.entryId = null;
    this.refObject = {};

    if (!BsyUtils.Store.get(`myAppGuideStatus`)) {
      // 处理我的应用引导
      this.deBounceMyAppGuide = BsyUtils.deBounce(this.renderMyAppGuide, 100);
    }
    this.showGuide = false;
  }

  onLayoutChange = (res) => {
    // const nowComponents = res.map((it) => {
    //   return {
    //     x: it.x,
    //     y: it.y,
    //     w: it.w,
    //     h: it.h,
    //   };
    // });
    // const staticComponents = this.state.components.map((it) => {
    //   return {
    //     x: it.x,
    //     y: it.y,
    //     w: it.w,
    //     h: it.h,
    //   };
    // });
    // if (_.isEqual(nowComponents, staticComponents)) {
    //   console.log("布局未发生变化");
    //   this.setState({
    //     components: this.state.components.map((it, index) => {
    //       return {
    //         ...it,
    //         ...nowComponents[index],
    //         static: true,
    //       };
    //     }),
    //   });
    //   return;
    // }
  };

  getCustomConfig = () => {
    // /corp/custom_config
    const { dockItem } = this.state;
    React.axios("/corp/custom_config", {})
      .then((res) => {
        let dash = [];
        if (!Array.isArray(res.data.customDash.dash)) {
          BsyUtils.forEach(res.data.customDash.dash, (index, data) => {
            dash.push(data);
          });
          res.data.customDash.dash = dash;
        }
        const newPc = filterDuplicateWidgets(res.data.layout.pc);
        const { components, customDash } = BsyUtils.getSurplusDash(
          newPc,
          res.data.customDash.dash,
          res.data.customDash.dashExist
        );

        let newComponents = [...components];
        const find = components.findIndex((it) => it.id === "dockApp");
        if (BsyUtils.isObjectEmpty(dockItem)) {
          //无互联要去除外部应用，重新给Y位置排序
          if (find > -1) {
            // let fsy = components[find].y;
            newComponents = components.filter((it) => it.id !== "dockApp");
            // .map((it, index) => {
            //   if (index >= find) {
            //     return {
            //       ...it,
            //       // y: it.y - fsy,
            //     };
            //   }
            //   return it;
            // });
          }
        } else {
          if (find === -1) {
            //有的话追加最后位置
            const lastComponent = components[components.length - 1];
            newComponents = [
              ...components,
              {
                x: 0,
                y: lastComponent.y + lastComponent.h,
                w: 60,
                h: 8,
                minW: 60,
                minH: 8,
                maxH: 8,
                name: React.language("app.dock"),
                id: "dockApp",
                disable: false,
                widget: createWidgetName(),
              },
            ];
          }
        }

        normalizeComponents(newComponents, res.data);

        this.setState({
          components: [...newComponents],
          customApp: { ...res.data.customApp },
          dockApp: { ...res.data.dockApp },
          customDash: {
            dash: customDash,
            enable: true,
          },
          carouselMap: { ...res.data.carouselMap },
          richText: { ...res.data.richText },
          recentUse: { ...res.data.recentUse },
          preferences: { ...res.data.preferences },
          noticeBoard: { ...res.data.noticeBoard },
          flowManagementType: res.data.flowManagementType,
          speedyEntry: { ...res.data.speedyEntry },
          dash_id: res.data.id,
          myDash: res.data.charts
            ? {
              dash: res.data.charts,
              enable: true,
            }
            : {
              dash: [],
              enable: true,
            },
        });
      })
      .catch((res) => {
        console.error(res);
      });
  };

  //设置工作台最后一次访问的页面
  setEntryCache = () => {
    let key = "_appID_" + window.FX.STATIC.user._id + window.FX.STATIC.corpId;
    let contText = BsyUtils.Store.get(key) || {};
    contText[window.FX.STATIC.corpId] = {
      ...contText[window.FX.STATIC.corpId],
      selectAppid: null,
      user_id: window.FX.STATIC["user"]._id,
    };
    BsyUtils.Store.set(key, contText);
  };

  // 处理我的应用引导
  renderMyAppGuide = () => {
    // console.log(`renderMyAppGuide ${new Date().getTime()}`);

    if (this.showGuide) {
      return;
    }
    this.showGuide = true;

    const that = this;
    const myAppElement = document.querySelector(".bsy-dashboard-myApp");
    if (myAppElement) {
      function showGuide() {
        const myAppReact = myAppElement?.getBoundingClientRect?.();
        console.log("getBoundingClientRect", myAppReact);
        BsyMaskLayer({
          customCls: "sloading5",
          onContentCreate: (ref) => {
            // if (that.showGuideRef) {
            //   that.showGuideRef.close();
            // }
            // that.showGuideRef = ref;
            return (
              <BsyMyAppGuide
                onClose={() => {
                  ref.close();
                  BsyUtils.Store.set("myAppGuideStatus", 1);
                  myAppElement.scrollIntoView({
                    block: "nearest",
                    behavior: "smooth",
                  });
                }}
              />
            );
          },
        });
      }

      showGuide();

      // const boydScroll = document.querySelector(".bsy-dashboard-centent-pane");
      // console.log(boydScroll.scrollHeight);
      // console.log(boydScroll.offsetHeight);

      // if (boydScroll.scrollHeight === boydScroll.offsetHeight) {
      //   showGuide();
      //   return;
      // }
      // let isScrolling;
      // const scroll = () => {
      //   // 清除之前的定时器
      //   clearTimeout(isScrolling);
      //   // 设置新的定时器
      //   isScrolling = setTimeout(() => {
      //     boydScroll.removeEventListener("scroll", scroll);
      //     setTimeout(() => {
      //       showGuide();
      //     }, 300);
      //   }, 50);
      // };
      // if (!that.showGuideRef) {
      //   boydScroll.addEventListener("scroll", scroll);
      // }
    }
  };

  resetCenter = (opt) => {
    const { components, rowHeight, noticeBoard } = this.state;
    let newComponents = [];
    let newComponents2 = JSON.parse(JSON.stringify(components));
    let addY = 0;
    let hasRender = false; //高度是否有变化，有变化需要重新渲染

    // grid 块高的计算公式  var row = 18,padding = 16; h=13; h * row + (h - 1) * padding = 426
    // var row = 18,padding = 16; (435 + padding) / (18+padding) = 13

    // 定义组件高度计算函数
    const calculateComponentHeight = (selector, type, padding = 16) => {
      // if (selector === ".myApp") {
      // const height =
      //   document.querySelector(
      //     `.bsy-dashboard-centent-pane .bsy-component${selector} `
      //   )?.scrollHeight || 0;
      // return Math.ceil((height + padding) / (rowHeight + padding));
      // }
      let header = 20;
      switch (type) {
        case "myApp":
        case "dockApp":
          header = 32;
          break;
        case "speedyEntryV2":
          header = 34; //20高度，14外边距 
          break;
        default:
          break;
      }

      let height =
        (document.querySelector(
          `.bsy-dashboard-centent-pane .bsy-component${selector} .component-body`
        )?.scrollHeight || 0) +
        header +
        40; // 34 是组件头部高度，40是组件统一内边距


      // if (type === "noticeBoard") {
      //   //公告栏特殊处理
      //   height =
      //     (document.querySelector(
      //       `.bsy-dashboard-centent-pane .bsy-component${selector} .component-body`
      //     )?.scrollHeight || 0) +
      //     (noticeBoard.isShowMoreTitle || noticeBoard.isShowTitle ? 60 : 40);
      // }
      return Math.ceil((height + padding) / (rowHeight + padding));
    };

    // 定义组件类型映射
    let componentMap = {
      myApp: ".myApp",
      myDash: ".myDash",
      favorites: ".favorites",
      dockApp: ".dockApp",
      recentUse: ".recentUse",
      // noticeBoard: ".noticeBoard",
    };
    // if (opt?.type === "myApp") {
    //   componentMap.myApp = ".myApp";
    // }
    //快捷入口动态添加---------------satat
    // let speedyEntryV2List = newComponents2.filter((item) => {
    //   return item.id.includes("speedyEntryV2");
    // });
    // speedyEntryV2List.forEach((item) => {
    //   componentMap[item.id] = "." + [item.id];
    // });
    //快捷入口动态添加 ----------------end
    // 20250313 bobo 屏蔽y的计算，只计算h，其他的由组件(react-grid-layout)自行计算，目前没有发现问题，根据实际情况后续调整
    newComponents2.map((res, key) => {
      const selector = componentMap[res.id];

      if (selector) {
        let centerYH = calculateComponentHeight(selector, res.id);
        if (res.id === "myDash") {
          if (centerYH < 6) {
            centerYH = 6;
          }
        }
        if (res.id === "favorites") {
          if (centerYH < 6) {
            centerYH = 6;
          }
        }
        if (centerYH !== res.h) {
          hasRender = true;
          res.h = centerYH;
          // if (key !== 0) {
          //   if (res.y !== 0) {
          //     res.y = components[key].y + addY;
          //     console.log("重置y", components[key].name);
          //   }
          // }
          // addY += centerYH - components[key].h;
        }
      } else {
        // if (res.y !== 0) {
        //   res.y = components[key].y + addY;
        //   console.log("重置y", components[key].name);
        // }
      }
      newComponents.push(res);
      return null;
    });
    if (hasRender) {
      // console.log("resetCenter", JSON.stringify(newComponents));
      // // 创建一个 Map 来存储 y 值对应的 widget 列表
      // let yToIds = new Map();

      // // 遍历 arr1，记录每个 y 值对应的 widget 列表
      // for (let item of components) {
      //   if (!yToIds.has(item.y)) {
      //     yToIds.set(item.y, []);
      //   }
      //   yToIds.get(item.y).push(item.widget);
      // }

      // // 创建一个 Map 来存储 id 和 y 的映射关系
      // let idToY = new Map();
      // for (let item of components) {
      //   idToY.set(item.widget, item.y);
      // }

      // // 遍历 arr2，更新 y 值
      // for (let item of newComponents) {
      //   if (idToY.has(item.widget)) {
      //     let yValue = idToY.get(item.widget); // 获取 arr1 中对应 id 的 y 值
      //     let idsWithSameY = yToIds.get(yValue); // 获取 arr1 中 y 值相同的所有 id
      //     if (idsWithSameY && idsWithSameY.length > 0) {
      //       // 将 arr2 中对应 id 的 y 值更新为 arr1 中 y 值相同的第一项的 y 值
      //       item.y = newComponents.find((i) => i.widget === idsWithSameY[0]).y;
      //     }
      //   }
      // }
      // const newLayout = this.adjustLayout(newComponents, 60);
      this.setState(
        {
          components: newComponents,
        },
        () => {
          this?.deBounceMyAppGuide?.();
        }
      );
    }
  };

  componentDidMount = () => {
    this.props.isPreview ? this.resetCenter() : this.getCustomConfig();
    this.setEntryCache();
    this.state.isPreview &&
      (document.querySelector(
        ".bsy-dashboard-centent-pane .react-grid-layout"
      ).style.pointerEvents = "none");
  };

  // onLayoutChange = (layout, layouts) => {
  //   this.props.onLayoutChange(layout, layouts);
  // };

  updateMyDash = (charts) => {
    const { dash_id } = this.state;
    React.axios("/corp/update_charts", {
      dash_id,
      charts: charts.map((it) => {
        const dd = { ...it };
        delete dd.widgetParams.appId;
        delete dd.widgetParams.entryId;
        delete dd.chosen;
        delete dd.selected;
        return dd;
      }),
    }).then((res) => {
      BsyUtils.showAjaxTip(res);
    });
  };

  onRefreshChars = (opt) => {
    switch (opt?.type) {
      case "myApp":
        this.resetCenter(opt);
        break;
      default:
        if (opt) {
          this.updateMyDash(opt.dash);
          this.setState({ myDash: opt }, () => {
            this.resetCenter();
          });
        } else {
          this.resetCenter();
        }
        break;
    }
  };

  // onMyDash = (component) => {
  //     this.setState({
  //         myDash: component
  //     })
  // }

  onUpdataApps = (apps, favoritesList) => {
    if (apps) {
      this.setState({
        apps: [...apps],
      });
    }

    if (favoritesList) {
      this.refObject["favorites"]?.favoritesContext?.favoritesList();
    }
  };

  render() {
    const {
      components,
      apps,
      customApp,
      customDash,
      dockApp,
      dockCorp,
      dockItem,
      preferences,
      myDash,
      carouselMap,
      richText,
      recentUse,
      flowManagementType,
      noticeBoard,
    } = this.state;
    setPageTitle(React.language("dashboard"));
    return (

      <div className="bsy-dashboard-centent-pane">
        {
          <ReactGridLayout
            {...this.props}
            margin={[16, 16]}
            onLayoutChange={this.onLayoutChange}
            // isBounded={false}
            // isDroppable={false}
            // static={true}
            isDraggable={false}
            // allowOverlap={false}
            // autoSize={true}
            useCSSTransforms={true}
            isResizable={false}

          // onDropDragOver={(e) => {
          //     let WH = this.getComponentsSize(this.currentDragElData)
          //     let newWH = { w: WH.w, h: WH.h }
          //     // const droppingItemX = e.nativeEvent.layerX;
          //     // const droppingItemY = e.nativeEvent.layerY;
          //     // console.log(`droppingItem 位置：(${droppingItemX}, ${droppingItemY})`, e);
          //     return newWH
          // }}
          >
            {components.map((block, index) => (
              <div
                className={`bsy-dashboard-${block.id} bsy-dashboard-item`}
                key={
                  block.id === "invalidBlock"
                    ? `${block.widget}-${index}` // 不知道是后端还是其他原因，没有权限的id会变成一样，前端需要区分，否则会重叠
                    : block.widget
                }
                data-x={block.x}
                data-y={block.y}
                data-w={block.w}
                data-h={block.h}
                data-grid={{
                  x: block.x,
                  y: block.y,
                  w: block.w,
                  h: block.h,
                }}
              >
                <BsyDashboardComponent
                  getContext={(el) => {
                    if (block.id === "favorites") {
                      this.refObject["favorites"] = el;
                    }
                  }}
                  block={block}
                  key={block.widget}
                  customApp={customApp}
                  dockCorp={dockCorp}
                  dockItem={dockItem}
                  dockApp={dockApp}
                  noticeBoard={noticeBoard}
                  richText={richText}
                  carouselMap={carouselMap}
                  recentUse={recentUse}
                  customDash={customDash}
                  flowManagementType={flowManagementType}
                  // speedyEntry={speedyEntry}
                  preferences={preferences}
                  myDash={myDash}
                  // onMyDash={this.onMyDash}
                  apps={apps}
                  mode={"visit"}
                  onRefreshChars={this.onRefreshChars}
                  onUpdataApps={this.onUpdataApps}
                />
              </div>
            ))}
          </ReactGridLayout>
        }
      </div>

    );
  }
}
